(ns frontend.view.modals.survey-template-email-editor.view
  (:require [cljs.reader :as edn]
            [clojure.data :as data]
            [common.languages :as languages]
            [common.localization :as loc]
            [common.schema.registry :as registry]
            [common.util :as cu]
            [frontend.state.current-session :as session]
            [ui.components.modal.view :as modal]
            [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :survey-template-email-editor-modal)

(defn lang-selector
  [state template]
  (let [options (->> (:survey-template/languages template)
                     (mapv (fn [l]
                             {:value l
                              :label (languages/get-label l)})))]
    [labelled-input/view
     {:editor-type :editor.type/select
      :value       (->> options
                        (cu/filter-by :value (get @state :lang :ENG))
                        first)
      :label       (loc/tr :language)
      :options     (->> (:survey-template/languages template)
                        (mapv (fn [l]
                                {:value (pr-str l)
                                 :label (languages/get-label l)})))
      :on-change   (fn [v]
                     (swap! state assoc :lang (edn/read-string v)))}]))


(def editable-fields [:survey-template/email-subject-localized
                      :survey-template/email-hero-image-localized
                      :survey-template/email-body-localized
                      :survey-template/email-button-text-localized
                      :survey-template/email-button-color-localized
                      :survey-template/email-button-text-color-localized
                      :survey-template/email-body-after-button-localized])

(defn localized-field-input
  [state lang attribute]
  (let [field-schema (registry/get-field-schema nil attribute)
        editor-type (:ui/default-editor-type field-schema)
        variable-source (:ui/variable-source field-schema)
        data-type (case editor-type
                    :editor.type/text-mention :data.type/text-simple
                    :editor.type/richtext-mention :data.type/text-richtext
                    :data.type/text-simple)]
    [labelled-input/view
     {:label           (loc/tr attribute)
      :value           (get-in @state [attribute lang])
      :data-type       data-type
      :editor-type     editor-type
      :variable-source variable-source
      :on-change       (fn [v]
                         (swap! state assoc-in [attribute lang] v))}]))

(defn view
  [{:keys [_shown? _close-modal! props state _topmost?]}]
  (let [{:keys [entity-id]} props
        template (session/get-entity entity-id)]
    (swap! state assoc :lang :ENG)
    (swap! state merge (select-keys template editable-fields))
    (fn [{:keys [shown? close-modal! props state topmost?]}]
      (let [lang (get @state :lang)
            {:keys [on-submit! entity-id]} props
            on-close! close-modal!
            [old new _unchanged] (data/diff (select-keys @state editable-fields)
                                            (select-keys template editable-fields))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :survey-email-texts [(:survey-template/label template)])
         [:div.flex.flex-col.flex-auto.gap-2
          [:div.flex.flex-col.shrink-0.grow-0
           [lang-selector state template]]
          [:div.flex.flex-col.flex-auto.gap-2
           [localized-field-input state lang :survey-template/email-subject-localized]
           [labelled-input/view
            {:label     (loc/tr :survey-template/email-hero-image-localized)
             :value     (get-in @state [:survey-template/email-hero-image-localized lang])
             :data-type :data.type/text-url
             :on-change (fn [v]
                          (swap! state assoc-in [:survey-template/email-hero-image-localized lang] v))}]
           ^{:key (str modal-key "-" lang "-1")}
           [localized-field-input state lang :survey-template/email-body-localized]
           [labelled-input/view
            {:label     (loc/tr :survey-template/email-button-text-localized)
             :value     (get-in @state [:survey-template/email-button-text-localized lang])
             :data-type :data.type/text-simple
             :on-change (fn [v]
                          (swap! state assoc-in [:survey-template/email-button-text-localized lang] v))}]
           [labelled-input/view
            {:label     (loc/tr :survey-template/email-button-text-color-localized)
             :value     (get-in @state [:survey-template/email-button-text-color-localized lang])
             :data-type :data.type/text-simple
             :on-change (fn [v]
                          (swap! state assoc-in [:survey-template/email-button-text-color-localized lang] v))}]
           [labelled-input/view
            {:label     (loc/tr :survey-template/email-button-color-localized)
             :value     (get-in @state [:survey-template/email-button-color-localized lang])
             :data-type :data.type/text-simple
             :on-change (fn [v]
                          (swap! state assoc-in [:survey-template/email-button-color-localized lang] v))}]
           ^{:key (str modal-key "-" lang "-2")}
           [localized-field-input state lang :survey-template/email-body-after-button-localized]
           ]]
         [modal/right-single-button
          nil
          (and (empty? old)
               (empty? new))
          (fn [_]
            (on-submit! (merge {:db/id entity-id}
                               (select-keys @state editable-fields)) on-close!))
          (loc/tr :save)
          nil]]))))
